import discardRegionalOption from './data/mutators/discardRegionalOption';
import saveRegionalOption from './orchestration/saveRegionalOption';
import isRegionalOptionDirty from './utils/isRegionalOptionDirty';
import DateFormatQuick from './view/DateFormatQuick';
import RegionalFull from './view/RegionalFull';
import TimeFormatQuick from './view/TimeFormatQuick';
import TimeZoneQuick from './view/TimeZoneQuick';
import { OwaWorkload } from 'owa-workloads';
import * as React from 'react';
import {
    Option,
    QuickSettingOrder,
    OptionQuickCustomRenderComponentProps,
    OptionQuickComponentSettingsWithKey,
} from 'owa-options-core';

let regionalQuickOptions: OptionQuickComponentSettingsWithKey[] = [
    {
        key: 'regional_timeZone',
        rendering: {
            render: (props: OptionQuickCustomRenderComponentProps) => <TimeZoneQuick {...props} />,
        },
        getOrder: () => QuickSettingOrder.TimeZone,
        workloads: OwaWorkload.Calendar,
        customTitle: 'option_regional_timeZone',
    },
    {
        key: 'regional_dateFormat',
        rendering: {
            render: (props: OptionQuickCustomRenderComponentProps) => (
                <DateFormatQuick {...props} />
            ),
        },
        getOrder: () => QuickSettingOrder.DateFormat,
        workloads: OwaWorkload.Calendar,
        customTitle: 'option_regional_dateFormatWithoutExample',
    },
    {
        key: 'regional_timeFormat',
        rendering: {
            render: (props: OptionQuickCustomRenderComponentProps) => (
                <TimeFormatQuick {...props} />
            ),
        },
        getOrder: () => QuickSettingOrder.TimeFormat,
        workloads: OwaWorkload.Calendar,
        customTitle: 'option_regional_timeFormat',
    },
];

let RegionalOption: Option = {
    key: 'regional',
    titleStringKey: 'optionTitle_regional',
    hideTitleInFullOptions: true,
    searchTermsStringKey: 'optionSearch_regional',
    fullOptionFormSettings: {
        render: () => <RegionalFull />,
        isDirty: isRegionalOptionDirty,
        onSave: saveRegionalOption,
        onDiscard: discardRegionalOption,
    },
    quickOptionSettings: regionalQuickOptions,
    allowedOptionKeys: ['Regional'],
};

export default RegionalOption;
